import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglemeetComponent } from './simple-icons-googlemeet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglemeetComponent ],
    exports:      [ SimpleIconsGooglemeetComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglemeetModule {}
